function swymCallbackFn(swat){
    // your API calls go here
    document.addEventListener("swym:refresh", function(){
        setTimeout(() => {
            swat.initializeActionButtons(".collection__content");
        },1000)
    });
    // Define the event listener function
    let listener = function(e) { 
      const request = new XMLHttpRequest();
      request.addEventListener('load', handleResponse);
      request.open('GET', '/?sections=cart-drawer,cart-icon-bubble,cart-icon-bubble-sticky', true);
      request.send();

      function handleResponse() {
        const data = JSON.parse(this.responseText);

        function updateElement(tempHTML, selector, replaceSelf) {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = tempHTML;
          const target = document.querySelector(selector);
          const source = tempDiv.querySelector(selector);
          if (target && source) {
            replaceSelf ? target.replaceWith(source) : target.innerHTML = source.innerHTML;
          }
        }

        updateElement(data['cart-drawer'], 'cart-drawer', true);
        updateElement(data['cart-icon-bubble'], '#cart-icon-bubble', false);
        updateElement(data['cart-icon-bubble-sticky'], '#cart-icon-bubble-sticky', false);

        document.querySelector('cart-drawer')?.open();
      }

    };

    // Add listener for the 'addedtocart' event to the Swym Event Layer 
    swat.evtLayer.addEventListener('sw:addedtocart', listener);
    
  }
  if(!window.SwymCallbacks){
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(swymCallbackFn);
